import React from 'react';
import omit from 'lodash/omit';

import styles from './create-change-indicated-component.styles';

function getSignedStyles(number, onlyNegativeStyling, renderProps) {
  const sign = Math.sign(number);

  if (sign === -1) {
    return styles.negative;
  }

  if (!onlyNegativeStyling && sign > 0) {
    return styles.positive;
  }

  if (renderProps && renderProps.color) {
    if(renderProps.isFutureValueColor){
     return styles.futureValueDateActive
    }
   else { 
    return styles.secondaryActive
  };
  }

  return styles.neutral;
}

export default function (WrappedComponent) {
  function ChangeIndicatedComponent(props) {
    const { value, onlyNegativeStyling, renderProps } = props;
    const style = props && props.renderProps && props.renderProps.style;
    const signedStyles = getSignedStyles(value, onlyNegativeStyling, renderProps);
    const givenStyles = style ? [style, signedStyles] : [signedStyles];
    const modifiedProps = Object.assign({}, omit(props, 'renderProps'));
    modifiedProps.renderProps = Object.assign({}, renderProps, {
      style: givenStyles,
    });   

    const render = txt =>
      modifiedProps.children.call(modifiedProps, txt, renderProps);
     
return (
    <WrappedComponent {...modifiedProps}>{
        modifiedProps.children && render
      }</WrappedComponent>
  );
  }

  ChangeIndicatedComponent.defaultProps = {
    onlyNegativeStyling: false,
  };

  ChangeIndicatedComponent.propTypes = WrappedComponent.propTypes;

  return ChangeIndicatedComponent;
}
